<ng-template #displayTemplateRef
             let-cellData>
  <span scOverflowTooltip
        [tooltipDisabled]="tableColumn.settings.wrap">
    {{ getCellValue(cellData) }}
  </span>
</ng-template>

<ng-template #editableTemplateRef
             let-rowData="rowData">

  @if (!multilineEdit) {
    <input pInputText
           scValidatable
           [scValidatableTooltip]="tableColumn.settings.editable.showValidationTooltip"
           [scEditableCellValidation]="tableColumn"
           [(ngModel)]="rowData[tableColumn.field]">
  }

  @if (multilineEdit) {
    <textarea pTextarea
              pAutoResize
              scValidatable
              [scValidatableTooltip]="tableColumn.settings.editable.showValidationTooltip"
              [scEditableCellValidation]="tableColumn"
              [(ngModel)]="rowData[tableColumn.field]"></textarea>
  }
</ng-template>